export default __webpack_public_path__ + "static/media/Streets-1613431491272.38076590.png";